export enum EPreferences {
  /** Default cart-display radio only. Does not show or hide Pack & Ship. */
  PACK_AND_SHIP_CART_DISPLAY = "PACK_AND_SHIP_CART_DISPLAY",
  /** Section Pack & Ship opens on for quotes and orders (PACKAGING / SHIPPING). */
  DEFAULT_PACK_AND_SHIP_SECTION = "DEFAULT_PACK_AND_SHIP_SECTION",
  /** When true, auto-optimize packages on packaging modal/page open (button always shown). */
  AUTO_OPTIMIZE_PACKAGE = "AUTO_OPTIMIZE_PACKAGE",
  PRINTING_MATERIAL_SEPARATION = "PRINTING_MATERIAL_SEPARATION",
  ROUND_PRICING = "ROUND_PRICING",
  System_VAT = "System_VAT",
  DEFUALT_AUTO_DISCOUNT = "DEFUALT_AUTO_DISCOUNT",
  DOCUMENT_AGENT = "DOCUMENT_AGENT",
  PRODUCTION_TICKET_SIZE = "PRODUCTION_TICKET_SIZE",
  SHOW_PHONE_PREFIX = "SHOW_PHONE_PREFIX",
  SHOW_CUSTOMER_SUPPORT_REPRESENTATIVE = "SHOW_CUSTOMER_SUPPORT_REPRESENTATIVE",
  SET_QUOTE_CREATOR_AS_QUOTE_AGENT = "SET_QUOTE_CREATOR_AS_QUOTE_AGENT",
  ADDITIONAL_DELIVERY_TIME = "ADDITIONAL_DELIVERY_TIME",
  SHOW_DISCOUNT_ITEMS = "SHOW_DISCOUNT_ITEMS",
  DELIVERY_TICKET_SIZE = "DELIVERY_TICKET_SIZE",
  SHOW_DELIVERY_ITEMS = "SHOW_DELIVERY_ITEMS",
  IGNORE_IN_CALCULATED_WORKFLOWS = "IGNORE_IN_CALCULATED_WORKFLOWS",
  SHOW_GRAPHICS_ITEMS = "SHOW_GRAPHICS_ITEMS",
  BOARDMISSION_PDF_FORMAT = "BOARDMISSION_PDF_FORMAT",
  DOCUMENT_PDF_PAGE_SIZE = "DOCUMENT_PDF_PAGE_SIZE",
  SHOW_AGENT_IN_PRODUCTION_FLOOR = "SHOW_AGENT_IN_PRODUCTION_FLOOR",
  ALLOWS_USERS_TO_MANAGE_ALL_SUB_JOBS = "ALLOWS_USERS_TO_MANAGE_ALL_SUB_JOBS",
  PRODUCTION_FLOOR_TABLE_FONT_SIZE = "PRODUCTION_FLOOR_TABLE_FONT_SIZE",
  SHOW_PRODUCT_NAME_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_PRODUCT_NAME_COLUMN_IN_PRODUCTION_FLOOR",
  SHOW_DESCRIPTION_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_DESCRIPTION_COLUMN_IN_PRODUCTION_FLOOR",
  SHOW_NOTES_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_NOTES_COLUMN_IN_PRODUCTION_FLOOR",
  USE_DIRECT_BOARDMISSION_QR_HANDLER = "USE_DIRECT_BOARDMISSION_QR_HANDLER",
  RUSH_FEE = "RUSH_FEE",
  HIDE_VAT_FROM_DOCUMENTS = "HIDE_VAT_FROM_DOCUMENTS",
  ADDRESSES_WITH_COUNTRY_AND_STATE = "ADDRESSES_WITH_COUNTRY_AND_STATE",
  ADDRESSES_REQUIRED_FOR_ORDER = "ADDRESSES_REQUIRED_FOR_ORDER",
  HIDE_ITEM_CODE_FROM_DOCUMENT_CART = "HIDE_ITEM_CODE_FROM_DOCUMENT_CART",
  USE_PRINTNODE_AFTER_PREPRESS = "USE_PRINTNODE_AFTER_PREPRESS",
  SKIP_PREPRESS_STATION_AFTER_APPROVE_PROOF = "SKIP_PREPRESS_STATION_AFTER_APPROVE_PROOF",
  INITIALIZE_ORDER_FOLDERS_AFTER_CREATION = "INITIALIZE_ORDER_FOLDERS_AFTER_CREATION",
  DEFAULT_PAYMENT_TERMS = "DEFAULT_PAYMENT_TERMS",
  DEFAULT_NUMBER_OF_ROWS_IN_TABLES = "DEFAULT_NUMBER_OF_ROWS_IN_TABLES",
  AGENT_REQUIRED_IN_DOC = "AGENT_REQUIRED_IN_DOC",
  DELIVERY_DATE_REQUIRED_IN_DOC = "DELIVERY_DATE_REQUIRED_IN_DOC",
  USE_PRINTNODE_AFTER_UPLOAD_FILE = "USE_PRINTNODE_AFTER_UPLOAD_FILE",
  SET_CURRENT_USER_AS_CLIENT_AGENT = "SET_CURRENT_USER_AS_CLIENT_AGENT",
  ASK_TO_PRINT_WITH_PRICES_IN_DELIVERY_NOTES = "ASK_TO_PRINT_WITH_PRICES_IN_DELIVERY_NOTES",
  ASK_TO_GROUP_SIMILAR_JOBS = "ASK_TO_GROUP_SIMILAR_JOBS",
  DELIVERY_DATE_REQUIRED_IN_QUOTE = "DELIVERY_DATE_REQUIRED_IN_QUOTE",
  USE_JOBS_TIMELINE = "USE_JOBS_TIMELINE",
  /**
   * Defaults to disabled when the print-house catalog does not contain this code.
   * Turning it on requires the preference to be added in the print-house preference catalog.
   */
  ENABLE_PRODUCTION_COMPLETION_TARGET = "ENABLE_PRODUCTION_COMPLETION_TARGET",
  AGENT_REQUIRED_IN_QUOTE = "AGENT_REQUIRED_IN_QUOTE",
  CHECK_CUSTOMER_REQUIRED_FIELDS_IN_QUOTE =
    "CHECK_CUSTOMER_REQUIRED_FIELDS_IN_QUOTE",
  KANBAN_CARD_HIGHLIGHTING_STYLE = "KANBAN_CARD_HIGHLIGHTING_STYLE",
  RELATED_DOCUMENT_CLICK_BEHAVIOR = "RELATED_DOCUMENT_CLICK_BEHAVIOR",
  IS_ALL_ITEMS_SELECTED_IN_QUOTE_CONFIRMATION = "IS_ALL_ITEMS_SELECTED_IN_QUOTE_CONFIRMATION",
  HIDE_NOTES_IN_APPROVAL = "HIDE_NOTES_IN_APPROVAL",
  SHOW_PACKAGES_AMOUNT = "SHOW_PACKAGES_AMOUNT",
  USE_PREDICTED_PRICE = "USE_PREDICTED_PRICE",
  CUSTOMERS_REQUIRED_FIELDS = "CUSTOMERS_REQUIRED_FIELDS",
  CUSTOMERS_ADDRESSES_REQUIRED_FIELDS = "CUSTOMERS_ADDRESSES_REQUIRED_FIELDS",
  CUSTOMERS_DELIVERY_ADDRESSES_REQUIRED_FIELDS =
    "CUSTOMERS_DELIVERY_ADDRESSES_REQUIRED_FIELDS",
  CUSTOMERS_BILLING_ADDRESSES_REQUIRED_FIELDS =
    "CUSTOMERS_BILLING_ADDRESSES_REQUIRED_FIELDS",
  CUSTOMERS_CONTACTS_REQUIRED_FIELDS = "CUSTOMERS_CONTACTS_REQUIRED_FIELDS",
  SUPPLIERS_REQUIRED_FIELDS = "SUPPLIERS_REQUIRED_FIELDS",
  SUPPLIERS_ADDRESSES_REQUIRED_FIELDS = "SUPPLIERS_ADDRESSES_REQUIRED_FIELDS",
  SUPPLIERS_CONTACTS_REQUIRED_FIELDS = "SUPPLIERS_CONTACTS_REQUIRED_FIELDS",
  DATE_FORMAT = "DATE_FORMAT",
  REQUIRE_NEW_DELIVERY_DATE_AFTER_GRAPHICS = "REQUIRE_NEW_DELIVERY_DATE_AFTER_GRAPHICS",
  ASK_TO_COMPLETE_GRAPHICS_PREPRESS_ACROSS_SECTIONS = "ASK_TO_COMPLETE_GRAPHICS_PREPRESS_ACROSS_SECTIONS",
  FINAL_PRICE_UPDATE_BEHAVIOR = "FINAL_PRICE_UPDATE_BEHAVIOR",
  UI_STYLESHEET = "UI_STYLESHEET",
}
